import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function OrderPolicy() {
  return (
    <PolicyPage title="Order & Cancellation Policy">
      <h2>Order review</h2>
      <p>Review products, quantities, options, delivery details, and the final total before paying. An order number or acknowledgment means we received the request; it does not guarantee acceptance or stock.</p>

      <h2>Changing or cancelling an order</h2>
      <p>Email us as soon as possible. We will try to help, but changes or cancellation cannot be guaranteed after packing, personalization, payment settlement, or shipment begins. If cancellation is no longer possible, an eligible item may be returned under our Returns Policy.</p>

      <h2>Pre-orders and backorders</h2>
      <p>If offered, an estimated release or restock date will be stated on the listing. Dates may change. Orders containing in-stock and delayed items may ship together or separately. You may request cancellation before dispatch unless the item is personalized or another lawful exception applies.</p>

      <h2>Order limits and resale</h2>
      <p>We may apply reasonable quantity limits, including per person, household, address, account, or payment method. Retail purchases are for personal or gift use unless we approve resale or wholesale terms in writing.</p>

      <h2>When we may cancel</h2>
      <p>We may cancel all or part of an order because of unavailability, an obvious error, failed payment, suspected fraud, a legal restriction, an unsupported destination, abusive conduct, or circumstances outside reasonable control. We will notify you and return payment collected for cancelled items.</p>

      <h2>Address corrections</h2>
      <p>Send corrections promptly. A carrier reroute may be unavailable or may incur a fee. If an order is returned because an address was incomplete or delivery was refused, we may deduct unrecoverable shipping and handling costs where law permits.</p>

      <h2>Contact</h2>
      <p>Include your order number when emailing <ContactEmail />.</p>
    </PolicyPage>
  );
}

export default OrderPolicy;
